import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { StackSidebarWatch } from "./PlayerSidebar.styles";
import type { PlayerSidebarProps } from "./PlayerSidebar.types";
import { UpcomingActivityItem } from "./UpcomingActivityItem.component";
import { CardTabsAttachment, CardTabsLink } from "../../components";
import { SideBarBoxRestyle } from "../NavigationSidebar/SidebarBox.component";

export function PlayerSidebar({
  usefulLinks,
  tools,
  upcomingActivities,
  currentActivityId,
  disabled,
  courseId,
  rootId
}: PlayerSidebarProps) {
  const { t } = useTranslation();

  const hasLinks = usefulLinks.length > 0;
  const hasTools = tools.length > 0;
  const hasUpcomingActivities = upcomingActivities.length > 0;

  if (!hasLinks && !hasTools && !hasUpcomingActivities) {
    return null;
  }

  return (
    <StackSidebarWatch
      id="player-sidebar"
      data-testid="player-sidebar-root"
      role="complementary"
      aria-label={ t("related_content") }
    >
      { hasLinks && (
        <SideBarBoxRestyle title={ t("sidebar_links") }>
          <Stack gap="0.5rem">
            { usefulLinks.map((link, index) => (
              <CardTabsLink
                key={ `player-sidebar-link-${index}` }
                disabled={ disabled }
                description={ link.description }
                url_label={ link.url_label }
                url={ link.url }
              />
            )) }
          </Stack>
        </SideBarBoxRestyle>
      ) }
      { hasTools && (
        <SideBarBoxRestyle title={ t("sidebar_materials") }>
          <Stack gap="0.5rem">
            { tools.map((tool, index) => (
              <CardTabsAttachment
                key={ `player-sidebar-material-${index}` }
                disabled={ disabled }
                dimension={ tool.dimension }
                id={ tool.id }
                name={ tool.name }
                shortDescription={ tool.shortDescription }
              />
            )) }
          </Stack>
        </SideBarBoxRestyle>
      ) }
      { hasUpcomingActivities && (
        <SideBarBoxRestyle title={ t("sidebar_upcoming_activities") }>
          <Stack gap="0.5rem">
            { upcomingActivities.map((activity) => (
              <UpcomingActivityItem
                key={ `player-sidebar-upcoming-${activity.id}` }
                activity={ activity }
                courseId={ courseId }
                rootId={ rootId }
                isCurrent={ activity.id === currentActivityId }
              />
            )) }
          </Stack>
        </SideBarBoxRestyle>
      ) }
    </StackSidebarWatch>
  );
}
